import React from 'react';
import './footer.css';

function Footer() {
  return (
    <footer id="footer" className="footer">
      <div className="copyright">
        &copy; Copyright{' '}
        <strong>
          <span>Finance</span>
        </strong>
        . All Rights Reserved
      </div>
      <div className="creadit">
        Designed by <a href="#toha">Thoha</a>
      </div>
    </footer>
  );
}

export default Footer;
